import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { href: "#top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", _hoisted_1, [
      _createVNode(_component_v_btn, {
        text: "",
        block: "",
        "x-large": "",
        class: "py-16"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("h2", {
            class: "text-center",
            style: {"color":"white !important"}
          }, " ☝️ Scroll to top ", -1)
        ])),
        _: 1,
        __: [0]
      })
    ])
  ]))
}